import React from 'react'
import {Button} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
 function BlockFour() {
    
  let history = useHistory();

  const redirect = () => {
    history.push('/maketavimas1')
    window.scrollTo(0, 0);
  }
    
    return (
        <div class="row penktasblokas sonai text-white">
        <div className="col-12 pav1 text-center  "> <p> MAKETAVIMAS</p></div>
            <div className="col-12"> <hr className="text-white-50"/></div>
            <div class="row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 .col-xl-6"> 
              <div class="row"> 
                <div class="col-2 h-25">
                <div class=" dot1"> </div>
                </div>
                <div class="col-10 pb-10"> 
                  <div class="font-italic">Padėsiu parengti įmonės prezentacijas, veiklos ataskaitas, atliksiu duomenų analizę bei sukursiu grafinius elementus.  </div>
                  <div  class="pt-4"><h5>PREZENTACIJŲ RENGIMAS</h5></div>
                  <div class="pb-5 text-warning">PREZI, MS PowerPoint, MS Excel, SPSS </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 .col-xl-6"> 
              <div class="row"> 
                <div class="col-2 h-25">
                <div class=" dot1"> </div>
                </div>
                <div class="col-10 pb-10"> 
                  <div class="font-italic">Nubraižysiu įvairius planus, aplinkos želdinimo projektus (3D vizualizacija) automatizuotojo projektavimo sistemomis. </div>
                  <div  class="pt-4"><h5>PLANŲ BRAIŽYMAS </h5></div>
                  <div class="pb-5 text-warning">Autocad, Realtime Landscaping Architect </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 .col-xl-6"> 
              <div class="row"> 
                <div class="col-2 h-25">
                <div class=" dot1"> </div>
                </div>
                <div class="col-10 pb-10"> 
                  <div class="font-italic">Sumaketuosiu įvairius leidinius, posterius, knygų viršelius, paruošiu leidybai. </div>
                  <div  class="pt-4"><h5>LEIDINIŲ MAKETAVIMAS</h5></div>
                  <div class="pb-5 text-warning">Unlead PhotoImpact </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 .col-xl-6"> 
              <div class="row"> 
                <div class="col-2 h-25">
                <div class=" dot1"> </div>
                </div>
                <div class="col-10 pb-10"> 
                  <div class="font-italic">Parengsiu reklamines užsklandas interneto svetainėms, įmonės logotipą.</div>
                  <div  class="pt-4"><h5>REKLAMOS MAKETAVIMAS</h5></div>
                  <div class="pb-5 text-warning">Unlead PhotoImpact, Inkscape </div>
                </div>
              </div>
            </div>
            </div>
      <div class="col-md-12 text-center ">
        <Button className="button" onClick={redirect} variant="amber"  active type="submit">ATLIKTI DARBAI</Button>
   
      </div> 
    </div>
    )
}
export default BlockFour